<template>
  <div v-if="totalPages > 1" class="base-pagination">
    <SvoiPagination :base-url="baseUrl" :active-page="activePage" :total-pages="totalPages" :max-points="maxPoints" />
  </div>
</template>

<script lang="ts" setup>
import { SvoiPagination } from '@svoi-ui/components/pagination'

withDefaults(defineProps<{
  baseUrl: string
  activePage?: number
  totalPages?: number
}>(), {
  activePage: 1,
  totalPages: 1,
})

const { isMobile } = useBreakpoint()
const maxPoints = computed(() => isMobile.value ? 7 : 9)
</script>

<style lang="scss" scoped>
.base-pagination {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
